<div class="h-100">
    <div [hidden]="isLoading" class="cards-wrapper">
        @for(group of data.groups; track group) {
            <div class="row w-100">
                @for(metric of group.metrics; track metric) {
                    <div class="d-flex" [ngClass]="getTileClass(metric?.size)">
                        <app-metric-card-view class="w-100" [metric]="metric" [customClass]="customClasses"></app-metric-card-view>
                    </div>
                }
            </div>
        }
    </div>
    <div class="h-100" *ngIf="isLoading">
        <app-loading [text]="'Loading dashboard data'"></app-loading>
    </div>
</div>